/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Icon, Pressable } from '@components/atoms'
import { mono, boSize, boAdmin } from '@components/systems/backoffice/backoffice.tokens'

import { useAppSelector, useAppDispatch, configActions } from '@redux/index'

/** 사이드바 접기/펴기 — 헤어라인 사각 22, 셰브론 하나. hover 확대 없음 */
export const DrawerToggleButton = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const isOpenDrawer: boolean = useAppSelector(state => state.config.isOpenDrawer)
	const mode: 'main' | 'admin' = useAppSelector(state => state.config.mode)

	const onToggleClick = React.useCallback(() => {
		reduxDispatch(configActions.IS_OPEN_DRAWER(!isOpenDrawer))
	}, [isOpenDrawer])

	return (
		<Pressable
			// 관리자 모드면 관리자 모드 칸과 상단 바 사이 이음새에 선다 — 띠 색 위의 흰 선 사각
			className={`toggleButton ${mode === 'admin' ? 'admin' : ''}`}
			css={style}
			onClick={onToggleClick}
			aria-label={isOpenDrawer ? '메뉴 접기' : '메뉴 펴기'}
		>
			<Icon
				className="toggleIcon"
				name={isOpenDrawer ? 'chevron-left' : 'chevron-right'}
			/>
		</Pressable>
	)
}

const style = css({
	position: 'absolute',
	zIndex: 10000,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: 22,
	height: 22,
	top: (boSize.navH - 22) / 2,
	right: -11,
	padding: 0,
	borderRadius: 2,
	background: mono.surface,
	border: `1px solid ${mono.lineSoft}`,
	transition: 'border-color 200ms ease-out',

	'.toggleIcon': {
		fontSize: 16,
		color: mono.dim,
		transition: 'color 200ms ease-out',
	},

	'&:hover': {
		borderColor: mono.ink,
		'.toggleIcon': { color: mono.ink },
	},

	'&.admin': {
		background: boAdmin.bar,
		borderColor: boAdmin.text,
		'.toggleIcon': { color: boAdmin.textOn },
		'&:hover': { borderColor: boAdmin.textOn, background: boAdmin.barHover },
	},
})
